<template>
    <div id="q-app">
        <router-view />
    </div>
</template>
<script>
    import { preventRedirects } from '@/plugins/urlPaths'
    export default {
        name: 'App',
        created() {
            this.$q.dark.set(this.darkMode)
            this.$http.interceptors.response.use(
                (response) => {
                    return response
                },
                (error) => {
                    if (!error?.response) {
                        this.$router.push('/maintenance').catch(err => { })
                        return Promise.reject({ message: 'Failed to connect to server, try again later.' })
                    }
                    else if (error?.response?.status === 401) {
                        if (error?.response?.data?.message.includes('Authorization has been denied for this request.')) {
                            this.$store.dispatch('logout')
                            this.$q.notify({
                                badgeClass: 'hidden',
                                type: 'info',
                                message: 'Your session has ended, please sign in again'
                            })
                        }

                        const token = JSON.parse(localStorage.getItem('token'))
                        if (!token) return Promise.reject(error)

                        const now = new Date()
                        const expires = new Date(token.expires_in)

                        if (now < expires) return Promise.reject(error)
                        else {
                            this.$store.dispatch('logout')
                            if (!preventRedirects.includes(this.$route.path)) {
                                this.$q.notify({
                                    badgeClass: 'hidden',
                                    type: 'info',
                                    message: 'Your session has ended, please sign in again'
                                })
                            }
                        }
                    }
                    else if (error?.response?.status == 500 && error?.response?.data?.exceptionMessage == 'UserId not found.') {
                        this.$store.dispatch('logout')
                    }
                    else return Promise.reject(error)
                }
            )
        },
        computed: {
            darkMode() { return this.$store.getters.isDarkMode },
            isLoggedIn() { return this.$store.getters.isLoggedIn },
            user() { return this.$store.getters.authUser },
        },
        watch: {
            darkMode(newVal) {
                this.$q.dark.set(newVal)
            },
        },
        errorCaptured(err, vm, info) {

            if (typeof err !== 'object' || err === null) return;

            var newContext = {
                "\\src\\App.Vue": {
                    isLoggedIn: this.isLoggedIn,
                    user: this.user,
                },
            }

            if (!err._customContext) {
                err._customContext = {};
            }

            Object.assign(err._customContext, newContext);

            return;
        },
    }
</script>
